<template>
    <div class="flex flex-col">
      <div class="-my-2 sm:-mx-6 lg:-mx-8">
        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">

            <div class="bg-white shadow overflow-hidden sm:rounded-lg"  v-if="!isLoading">
                <div class="px-4 py-5 sm:px-6">
                  <p class="mt-1 max-w-2xl text-sm text-gray-500">
                    {{ title }}
                  </p>
                  <p class="font-xl font-bold mt-5">
                      {{ value }}
                  </p>
                </div>
            </div>

            <div class="bg-white shadow overflow-hidden sm:rounded-lg"  v-else>
                <div class="animate-pulse px-4 py-5 sm:px-6">
                    <p class="w-24 bg-gray-300 h-6 rounded-md">
                    </p>
                    <p class="w-12 bg-gray-300 h-4 rounded-md mt-5">
                    </p>
                </div>
            </div>

          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        endpoint: {
            type: String,
            required: true
        }
    },
    data: function () {
        return {
            value: false,
            isLoading: true
        }
	},
    methods: {
        async getData() {
            const self = this;

            window.axios.get(self.endpoint)
                .then(response => {
                    self.value = response.data.value;
                    self.isLoading = false;
                })
                .catch(error => {
                    console.log(error);
                });
        }
    },
    mounted() {
        this.getData();
    }
}
</script>
